import { r4Client, queryBuilderClient, DmsDatasourceApi } from '@/services'
import { r4Error } from '../../services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('queryBuilderStore')

const QueryBuilderStore = {
  namespaced: true,
  state: {
    queriesList: [], // all saved queries from endpoint
    query: {}, // individual query retrieved
    queryParameters: [] // all parameters available to build a query
  },
  mutations: {
    storeQueriesList (state, queryResp) {
      state.queriesList = queryResp.data
    },
    storeQuery (state, queryResp) {
      if (queryResp.data) {
        state.query = queryResp.data
      } else {
        state.query = queryResp
      }
    },
    storeQueryParameters (state, payload) {
      state.queryParameters = payload.data
    }
  },
  actions: {
    fetchQueriesList ({ state, commit }) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/dms_datasources')
          .then(response => {
            commit('storeQueriesList', response.data)
            resolve(state.queriesList)
          })
          .catch(error => {
            logger.error('Error retrieving all queries', error.message)
            reject(error)
          })
      })
    },
    // All query parameters available for use
    fetchQueryParameters ({ state, commit }) {
      logger.trace('Fetching Available Queries!!!')
      return new Promise((resolve, reject) => {
        queryBuilderClient()
          .get('/api/v1/query_engine/queries')
          .then(response => {
            commit('storeQueryParameters', response.data)
            resolve(state.queryParameters.slice(0)) // return a copy else will modify source data
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    // fetches the saved query
    getQuery ({ state, commit }, queryId) {
      logger.trace(`Loading saved query ${queryId}`)
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/dms_datasources/' + queryId)
          .then(response => {
            commit('storeQuery', response.data)
            resolve(Object.assign({}, state.query)) // return a copy else will modify source data
          })
          .catch(error => {
            logger.error('Error retrieving query.', queryId, error.message)
            reject(r4Error(error))
          })
      })
    },
    getTemplate ({ state, commit }, queryId) {
      logger.trace(`Loading saved template ${queryId}`)
      return new Promise((resolve, reject) => {
        DmsDatasourceApi.getDmsDatasourceTemplate(queryId)
          .then(dsTemplate => {
            commit('storeQuery', dsTemplate)
            resolve(Object.assign({}, state.query)) // return a copy else will modify source data
          })
          .catch(error => {
            logger.error('Error retrieving query.', queryId, error.message)
            reject(error)
          })
      })
    },
    saveQuery ({ state, commit }, queryData) {
      const saveOp = function () {
        if (queryData.id) {
          logger.trace(`updating list ${queryData.id}`)
          return r4Client().put(`/api/v1/dms_datasources/${queryData.id}`, queryData)
        } else {
          logger.trace('creating list')
          return r4Client().post('/api/v1/dms_datasources', queryData)
        }
      }
      return new Promise((resolve, reject) => {
        saveOp()
          .then(response => {
            commit('storeQuery', response.data)
            resolve(Object.assign({}, state.query)) // return a copy else will modify source data
          })
          .catch(error => {
            logger.error('Error saving query', error.message)
            reject(r4Error(error))
          })
      })
    },
    saveTemplate ({ state, commit }, queryData) {
      return new Promise((resolve, reject) => {
        DmsDatasourceApi.saveDmsDatasourceTemplate(queryData)
          .then(dmsTemplate => {
            commit('storeQuery', dmsTemplate)
            resolve(Object.assign({}, state.query)) // return a copy else will modify source data
          })
          .catch(error => {
            logger.error('Error saving query', error.message)
            reject(error)
          })
      })
    },
    fetchPreviewData (context, previewParams) {
      return new Promise((resolve, reject) => {
        logger.trace(`PREVIEW PARAMS: ${JSON.stringify(previewParams)}`)
        queryBuilderClient()
          .post('/api/v1/query_engine/queries', previewParams)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            logger.error('RESP DATA:', error.message)
            reject(r4Error(error))
          })
      })
    }

    // setCurrentQueryByQueryId ({ dispatch, state, commit }, queryId) {
    //   const fetchQueriesPromise = state.queriesList.length === 0 ? dispatch('fetchQueriesList') : Promise.resolve()

    //   logger.trace('>>>> CURRENT QUERY BY: ', queryId)
    //   fetchQueriesPromise.then(() => {
    //     const currentQuery = state.queriesList.find(q => {
    //       return q.id === queryId
    //     })
    //     commit('storeQuery', currentQuery)
    //   })
    // }
  },
  getters: {
    // queryParamCategories: state => {
    //   const allCategories = state.queryParameters.map(queryParam => queryParam['category'])
    //   return [...new Set(allCategories)].sort() // use set to make unique list then convert back to array with spread
    // }
  }
}

export default QueryBuilderStore
